import {Component, Input, Output, EventEmitter} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
	ReactiveFormsModule,
	FormControl,
	AbstractControl,
} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatOptionModule} from '@angular/material/core';
import { TranslatePipe } from '@shared/pipes';

@Component({
	standalone: true,
	selector: 'input-selector',
	templateUrl: './input-selector.component.html',
	styles: [],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatInputModule,
		MatAutocompleteModule,
		MatOptionModule,
		TranslatePipe,
	],
})
export class InputSelectorComponent {
	@Input() control: FormControl | any = new FormControl();

	@Input() placeholder: string = '';
	@Input() type: string = 'text';
	@Input() checkValue: boolean = false;

	@Input() items: any[] = [];
	@Input() modifyFn: (item: any) => string = item => String(item);

	@Output() selectionChange = new EventEmitter<any>();

	onOptionSelected(event: any) {
		this.selectionChange.emit(event.option.value);
	}
}
